import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Alert, Button, Card, Descriptions } from "antd";

const DataFlowValidator = ({ children }) => {
  const { user, validateDataFlow } = useAuth();
  const [validation, setValidation] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (validateDataFlow) {
      const result = validateDataFlow();
      setValidation(result);
    }
  }, [user, validateDataFlow]);

  // Only show validation issues in development or when explicitly requested
  const isDevelopment = process.env.NODE_ENV === "development";
  const hasIssues = validation && !validation.isComplete;

  // In production, never interfere with normal flow
  if (!isDevelopment) {
    return children;
  }

  // In development, only show issues for non-superadmin users
  if (!showDetails && (!hasIssues || user?.role === "superadmin")) {
    return children;
  }

  if (hasIssues && user?.role === "admin") {
    return (
      <div style={{ padding: "20px" }}>
        <Alert
          message="Data Flow Issue Detected"
          description="There's an issue with the authentication data flow. Please check the details below."
          type="warning"
          showIcon
          style={{ marginBottom: "20px" }}
        />

        <Card
          title="Authentication Data Flow Status"
          style={{ marginBottom: "20px" }}
        >
          <Descriptions column={1} bordered>
            <Descriptions.Item label="Has Token" span={1}>
              {validation.hasToken ? "✅ Yes" : "❌ No"}
            </Descriptions.Item>
            <Descriptions.Item label="Has User Data" span={1}>
              {validation.hasUser ? "✅ Yes" : "❌ No"}
            </Descriptions.Item>
            <Descriptions.Item label="Has Role" span={1}>
              {validation.hasRole ? "✅ Yes" : "❌ No"}
            </Descriptions.Item>
            <Descriptions.Item label="Has Company ID" span={1}>
              {validation.hasCompanyId ? "✅ Yes" : "❌ No"}
            </Descriptions.Item>
            <Descriptions.Item label="Data Flow Complete" span={1}>
              {validation.isComplete ? "✅ Yes" : "❌ No"}
            </Descriptions.Item>
          </Descriptions>

          <div style={{ marginTop: "16px" }}>
            <Button
              type="primary"
              onClick={() => window.location.reload()}
              style={{ marginRight: "8px" }}
            >
              Retry Login
            </Button>
            <Button onClick={() => setShowDetails(false)}>
              Continue Anyway
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div>
      {isDevelopment && (
        <div
          style={{
            position: "fixed",
            top: "10px",
            right: "10px",
            zIndex: 9999,
            background: validation?.isComplete ? "#f6ffed" : "#fff2e8",
            border: `1px solid ${validation?.isComplete ? "#b7eb8f" : "#ffbb96"}`,
            borderRadius: "4px",
            padding: "8px 12px",
            fontSize: "12px",
          }}
        >
          Data Flow: {validation?.isComplete ? "✅ OK" : "⚠️ Issues"}
          <Button
            size="small"
            type="link"
            onClick={() => setShowDetails(!showDetails)}
            style={{ padding: "0 4px", fontSize: "12px" }}
          >
            {showDetails ? "Hide" : "Details"}
          </Button>
        </div>
      )}
      {children}
    </div>
  );
};

export default DataFlowValidator;
